import React from 'react';
import Platform from 'react-platform-js';
import { Link } from 'react-router-dom';
import {
  Button,
  Form,
  Input,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
} from 'reactstrap';

import history from '../../../utils/history';

const NO_MORE_QUESTIONS_TEXT = 'The user has no questions to answer';

class HelpPopUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showFirst: true,
      modal: this.props.isOpen,
      showDisableQuestionStep1: false,
      showDisableQuestionStep2: false,

      showReportQuestionStep1: false,
      showReportQuestionStep2: false,
      showReportQuestionStep3: false,
      showMoreAboutQuestions: false,

      selectedReport: null,
      reportTitle: '',
      reportDescription: '',
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen !== undefined) {
      this.setState({
        modal: nextProps.isOpen,
      });
    }
  }

  handleClick = () => {
    this.toggle();
  };

  openItercom = () => {
    window.Intercom('show');
    this.setState({ modal: false });
  };

  // disable question actions
  disableQuestion = () => {
    this.setState({ showDisableQuestionStep1: true, showFirst: false });
  };

  yesDisableQuestion = () => {
    const questionId = this.props.question.id;
    const chapterId = this.props.question.chapter;
    this.props.disableQuestion(questionId, chapterId);
    this.props.updateCounters(null, this.props.question.counterType);
    if (this.props.questionsData[0] === NO_MORE_QUESTIONS_TEXT) {
      history.push('/app/flashcard');
    } else {
      this.props.setQuestion(
        this.props.questionsData[0],
        this.props.questionsData,
      );
    }
    // TODO: handle the call to the api to disable the question
    this.setState({
      showDisableQuestionStep1: false,
      showDisableQuestionStep2: true,
    });
  };

  closeDisableQuestion = () => {
    this.setState({
      showDisableQuestionStep1: false,
      showDisableQuestionStep2: false,
      showReportQuestionStep1: false,
      showReportQuestionStep2: false,
      showReportQuestionStep3: false,
      showMoreAboutQuestions: false,
      modal: false,
    });
  };
  // report question actions

  changeReport = (value) => {
    this.setState({
      selectedReport: value,
    });
    switch (value) {
      case 'customRadio2':
        this.setState({
          hideTextQuestions1: true,
          hideTextQuestions2: false,
          hideTextQuestions3: false,
          hideTextQuestions4: false,
          reportTitle: "There's a typo or grammatical error here. ",
        });
        break;
      case 'customRadio3':
        this.setState({
          hideTextQuestions1: false,
          hideTextQuestions2: true,
          hideTextQuestions3: false,
          hideTextQuestions4: false,
          reportTitle: 'This answer is incorrect. ',
        });
        break;
      case 'customRadio4':
        this.setState({
          hideTextQuestions1: false,
          hideTextQuestions2: false,
          hideTextQuestions3: true,
          hideTextQuestions4: false,
          reportTitle: "There's an inaccuracy in technical information. ",
        });
        break;
      case 'customRadio5':
        this.setState({
          hideTextQuestions1: false,
          hideTextQuestions2: false,
          hideTextQuestions3: false,
          hideTextQuestions4: true,
          reportTitle: 'I see another issue. ',
        });
        break;
      default:
        this.setState({
          hideTextQuestions1: false,
          hideTextQuestions2: false,
          hideTextQuestions3: false,
          hideTextQuestions4: false,
          reportTitle: '',
        });
        break;
    }
  };

  changeReportText = (e) => {
    const aux = e.target.value;
    this.setState({ reportDescription: aux });
  };

  reportQuestion = () => {
    this.setState({ showReportQuestionStep1: true });
  };

  reportQuestionInput = () => {
    this.setState({ showReportQuestionStep2: true });
  };

  sendReport = () => {
    const reason = this.state.reportTitle + this.state.reportDescription;
    const platform = window.navigator.platform;
    const deviceData = {};
    deviceData.model = Platform.BrowserVersion;
    deviceData.version = Platform.Browser;
    deviceData.platform = platform;
    const where = 'web';

    const payload = {};
    payload.deviceData = deviceData;
    payload.where = where;
    payload.reason = reason;
    if (
      this.props.isStudyingSubmittedQuestions ||
      this.props.isStudyingMySubmittedQuestions
    ) {
      payload.isSubmittedQuestion = true;
    }

    this.props.reportQuestion(this.props.question.id, payload);
    if (this.props.title === 'Report Question') {
      this.props.disabledButton();
    }
    this.setState({
      showReportQuestionStep1: false,
      showReportQuestionStep3: true,
      selectedReport: null,
      reportTitle: '',
      reportDescription: '',
    });
  };

  // show more about questions
  showMoreAboutQuestions = () => {
    this.setState({ showMoreAboutQuestions: true });
  };

  // resetState is to hide all internal divs
  resetState = () => {
    this.props.handleClosePopUp();
    this.setState({
      showFirst: true,
      showDisableQuestionStep1: false,
      showDisableQuestionStep2: false,
      showReportQuestionStep1: false,
      hideTextQuestions1: false,
      hideTextQuestions2: false,
      hideTextQuestions3: false,
      hideTextQuestions4: false,
      showReportQuestionStep3: false,
      showMoreAboutQuestions: false,
    });
  };

  render() {
    const showFirst = this.state.showFirst ? ' show' : ' hide';
    const showDisableQuestionStep1 = `disable-question ${
      this.state.showDisableQuestionStep1 ? ' show' : ' hide'
    }`;
    const showDisableQuestionStep2 = `disable-question2 ${
      this.state.showDisableQuestionStep2 ? ' show' : ' hide'
    }`;
    const showReportQuestionStep1 = `disable-question ${
      this.state.showReportQuestionStep1 ? ' show' : ' hide'
    }`;
    const hideTextQuestions1 = this.state.hideTextQuestions1
      ? ' show'
      : ' hide';
    const hideTextQuestions2 = this.state.hideTextQuestions2
      ? ' show'
      : ' hide';
    const hideTextQuestions3 = this.state.hideTextQuestions3
      ? ' show'
      : ' hide';
    const hideTextQuestions4 = this.state.hideTextQuestions4
      ? ' show'
      : ' hide';
    const showReportQuestionStep3 = `disable-question ${
      this.state.showReportQuestionStep3 ? ' show' : ' hide'
    }`;
    const showMoreAboutQuestions = `disable-question ${
      this.state.showMoreAboutQuestions ? ' show' : ' hide'
    }`;

    return (
      <Modal
        isOpen={this.state.modal}
        toggle={this.toggle}
        className="help-popup modal-dialog-centered"
        onClosed={this.resetState}
      >
        <ModalBody>
          <div className={showFirst}>
            <ListGroup flush>
              {!window.location.href.includes('daily20quiz') && (
                <ListGroupItem
                  className="pointer d-flex justify-content-between"
                  onClick={this.disableQuestion}
                >
                  Disable Question <i className="icon-chevron_right" />
                </ListGroupItem>
              )}

              <ListGroupItem
                className="pointer  d-flex justify-content-between"
                onClick={this.reportQuestion}
              >
                Report Question <i className="icon-chevron_right" />
              </ListGroupItem>
              <ListGroupItem
                className="pointer  d-flex justify-content-between"
                onClick={this.openItercom}
              >
                Message Our Team <i className="icon-chevron_right" />
              </ListGroupItem>
              {!window.location.href.includes('daily20quiz') && (
                <ListGroupItem
                  className="pointer  d-flex justify-content-between"
                  onClick={this.showMoreAboutQuestions}
                >
                  More About Questions <i className="icon-chevron_right" />
                </ListGroupItem>
              )}
            </ListGroup>
          </div>
          <div className={showDisableQuestionStep1}>
            Are you sure you want to disable this question?
            <Button
              block
              color="link"
              className="btn-call-to-action"
              onClick={this.yesDisableQuestion}
            >
              YES, DISABLE.
            </Button>
          </div>
          <div className={showDisableQuestionStep2}>
            <span className="danger">
              This question has been disabled. you can enable disabled questions
              in <Link to="/app/account-settings">My Account</Link>
            </span>
            <Button
              block
              color="link"
              className="btn-call-to-action"
              onClick={this.closeDisableQuestion}
            >
              CLOSE
            </Button>
          </div>
          {
            //* ****************** */Report question
          }

          <div className={showReportQuestionStep1}>
            <Form>
              <ListGroup className="report-options" flush>
                <ListGroupItem className="pt-0">
                  <div className="custom-control custom-radio">
                    <input
                      name="error_type"
                      className="custom-control-input"
                      id="customRadio2"
                      onClick={() => this.changeReport('customRadio2')}
                      type="radio"
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadio2"
                    >
                      <span>There's a typo or grammatical error here</span>
                    </label>
                    <div className={hideTextQuestions1}>
                      <Input
                        name="reason"
                        className="input-sm"
                        onChange={this.changeReportText}
                        value={this.state.reportDescription}
                      />
                    </div>
                  </div>
                </ListGroupItem>
                <ListGroupItem>
                  <div className="custom-control custom-radio">
                    <input
                      name="error_type"
                      className="custom-control-input"
                      id="customRadio3"
                      onClick={() => this.changeReport('customRadio3')}
                      type="radio"
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadio3"
                    >
                      <span>This answer is incorrect</span>
                    </label>
                    <div className={hideTextQuestions2}>
                      <Input
                        name="reason"
                        className="input-sm"
                        onChange={this.changeReportText}
                        value={this.state.reportDescription}
                      />
                    </div>
                  </div>
                </ListGroupItem>
                <ListGroupItem>
                  <div className="custom-control custom-radio">
                    <input
                      name="error_type"
                      className="custom-control-input"
                      id="customRadio4"
                      onClick={() => this.changeReport('customRadio4')}
                      type="radio"
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadio4"
                    >
                      <span>
                        There's an inaccuracy in technical information
                      </span>
                    </label>
                    <div className={hideTextQuestions3}>
                      <Input
                        name="reason"
                        className="input-sm"
                        onChange={this.changeReportText}
                        value={this.state.reportDescription}
                      />
                    </div>
                  </div>
                </ListGroupItem>
                <ListGroupItem>
                  <div className="custom-control custom-radio">
                    <input
                      name="error_type"
                      className="custom-control-input"
                      id="customRadio5"
                      onClick={() => this.changeReport('customRadio5')}
                      type="radio"
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadio5"
                    >
                      <span>I see another issue</span>
                    </label>
                  </div>
                  <div className={hideTextQuestions4}>
                    <Input
                      name="reason"
                      className="input-sm"
                      onChange={this.changeReportText}
                      value={this.state.reportDescription}
                    />
                  </div>
                </ListGroupItem>
              </ListGroup>
              <div
                className={
                  this.state.selectedReport ? 'show mt-3' : 'hide mt-3'
                }
              >
                <Button
                  block
                  color="link"
                  className="btn-call-to-action"
                  onClick={this.sendReport}
                >
                  SEND REPORT
                </Button>
              </div>
            </Form>
          </div>
          <div className={showReportQuestionStep3}>
            <h3>Thanks for reporting this question!</h3>
            <p>
              We received your report and we're on it! You may receive an email
              from our team if additional information is required.
            </p>
            <Button
              block
              color="link"
              className="btn-call-to-action"
              onClick={this.closeDisableQuestion}
            >
              CLOSE
            </Button>
          </div>

          {
            //* ****************** */More about questions
          }
          <div className={showMoreAboutQuestions}>
            <div className="info-g info-new">
              <h4>New</h4>
              <p>Questions you have not seen yet.</p>
            </div>
            <div className="info-g info-learning">
              <h4>Learning</h4>
              <p>Questions you've answered incorrectly.</p>
            </div>
            <div className="info-g info-review">
              <h4>Review</h4>
              <p>
                Questions you've answered already and are due for review today.
              </p>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default HelpPopUp;
